(function () {
  'use strict';

  angular.module('tf.retailer.Util')
      .factory('Region', RegionClass);

  function RegionClass() {

    function Region(data) {
      if (!(this instanceof Region)) return new Region(data);
      this.setData(data);
    }

    _.extend(Region.prototype, {
      'constructor': Region,
      setData : function (data) {
        var that = this;
        that.label = data.regionCode;
        that.labelDescription = data.regionDescription;
      },
      getLabel: function () {
        return this.label;
      }
    });

    return Region;
  }


})();